module.exports = __webpack_public_path__ + "8264fddc9aa18c98f6f5ccbfdf837534.png";